import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const validationsKeyFactory = {
  validationBreakRunCount: (
    meterRunId: string,
    page: number
  ): [ModuleType, "validation-break-run-count", string, number] => [
    "mx",
    "validation-break-run-count",
    meterRunId,
    page,
  ],
  newMeterReadings: (
    meterRunId: string,
    page: number,
    searchData: string,
    premises,
    sortBy,
    readingId
  ): [
    ModuleType,
    "new-meter-readings",
    string,
    number,
    string,
    string[],
    string[],
    any
  ] => [
    "mx",
    "new-meter-readings",
    meterRunId,
    page,
    searchData,
    premises,
    sortBy,
    readingId,
  ],
  viewReadingsList: (
    meterRunId: string,
    ruleStatus: string,
    page: number,
    searchData,
    premises,
    sortBy,
    readingId
  ): [
    ModuleType,
    "view-readings-list",
    string,
    string,
    number,
    string,
    string[],
    string[],
    any
  ] => [
    "mx",
    "view-readings-list",
    meterRunId,
    ruleStatus,
    page,
    searchData,
    premises,
    sortBy,
    readingId,
  ],
  missingReadingsList: (
    page: number,
    searchData,
    premises,
    sortBy
  ): [
    ModuleType,
    "missing-readings-list",
    number,
    string,
    string[],
    string[]
  ] => ["mx", "missing-readings-list", page, searchData, premises, sortBy],
  exemptionList: (
    meterRunId: string,
    page: number,
    searchData,
    premises,
    sortBy,
    readingId
  ): [
    ModuleType,
    "exemptions",
    string,
    number,
    string,
    string[],
    string[],
    any
  ] => [
    "mx",
    "exemptions",
    meterRunId,
    page,
    searchData,
    premises,
    sortBy,
    readingId,
  ],
  viewMeterReadingDetail: (
    meterReadingId: string
  ): [ModuleType, "meter-reading-detail", string] => [
    "mx",
    "meter-reading-detail",
    meterReadingId,
  ],
  meterReadingConsumption: (
    meterNumber: string
  ): [ModuleType, "meter-reading-consumption", string] => [
    "mx",
    "meter-reading-consumption",
    meterNumber,
  ],
  previousReadingImage: (readingId): [ModuleType, "image", any] => [
    "mx",
    "image",
    readingId,
  ],
  routesList: (cycleId: number): [ModuleType, "routes", number] => [
    "mx",
    "routes",
    cycleId,
  ],
  routesListNavigation: (): [ModuleType, "routes"] => [
    "mx",
    "routes",
  ],
  validationCodes: (): [ModuleType, "validation-code"] => [
    "mx",
    "validation-code",
  ],
  reasonCodeList: (codeId: any): [ModuleType, "reason-code-list", any] => [
    "mx",
    "reason-code-list",
    codeId,
  ],
  sops: (): [ModuleType, "sops"] => ["mx", "sops"],
  validationBreakSummary: (): [ModuleType, "validation-break-summary"] => [
    "mx",
    "validation-break-summary",
  ],
  viewValidationBreakList: (
    page,
    filters,
    limit: number,
    search?: string,
    isCompleted?: boolean,
  ): [ModuleType, "validation-break-list", number, Record<string, any>, number, string?, boolean?,] => [
    "mx",
    "validation-break-list",
    page,
    filters,
    limit,
    search,
    isCompleted,
  ],
  utilityRules: (): [ModuleType, "validation-rules"] => [
    "mx",
    "validation-rules",
  ],
  meterCycleValidators: (search): [ModuleType, "meter-validators", string] => [
    "mx",
    "meter-validators",
    search,
  ],
  auditUsers: (userType: number, cycleId?: number, search?: string): [ModuleType, "audit-users", number, number, string] => [
    "mx",
    "audit-users",
    userType,
    cycleId,
    search
  ],
  routeList: (
    cycleIds: number[]
  ): [ModuleType, "meter-validators", number[]] => [
    "mx",
    "meter-validators",
    cycleIds,
  ],
  meterReaders: (): [ModuleType, EntityType, ActionType, any] => [
    "mx",
    "meter",
    "list",
    "meter-readers",
  ],
  duplicateReadings: (
    meterRunId: string,
    page: number,
    searchData: string,
    premises,
    sortBy,
    readingId
  ): [
    ModuleType,
    "new-meter-readings",
    string,
    number,
    string,
    string[],
    string[],
    any
  ] => [
    "mx",
    "new-meter-readings",
    meterRunId,
    page,
    searchData,
    premises,
    sortBy,
    readingId,
  ],
};
